import {
  DatasetDurationManager,
  DatasetSizeManager,
  DownloadResultManager,
} from "@/services/license/base/license-manager-abstractions";
import { VocalRemoverDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/vocal-remover-dataset-size-limiter";
import { VocalRemoverDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/vocal-remover-dataset-duration-limiter";
import { TrialDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/trial-download-result-limiter";

export class VocalRemoverLicenseManager
  implements DatasetDurationManager, DatasetSizeManager, DownloadResultManager
{
  datasetDurationLimiter = new VocalRemoverDatasetDurationLimiter();
  datasetSizeLimiter = new VocalRemoverDatasetSizeLimiter();
  downloadResultLimiter = new TrialDownloadResultLimiter();
}

const vocalRemoverLicenseManager = new VocalRemoverLicenseManager();
export { vocalRemoverLicenseManager };
